import Google from 'Classes/social-providers/Google';
import Apple from 'Classes/social-providers/Apple';

export default [
  Google,
  Apple,
];
